import React from 'react';
export var ActionBarContext = React.createContext('primary');
ActionBarContext.displayName = 'ActionBarContext';
export var SecondaryActionBarContext = React.createContext({
    setTopActionBarRef: function () { return null; },
});
SecondaryActionBarContext.displayName = 'SecondaryActionBarContext';
/**
 * Holds a boolean that tells us if any dialog is shown by our ActionBar controls.
 */
export var ActionBarDialogContext = React.createContext(false);
//# sourceMappingURL=ActionBarContext.js.map